import {
  createResource,
  fetchCollection,
  deleteResource
} from './index'

import { messageSchema } from '../schemas'

export const CREATE_WORK_ORDER_MESSAGE_REQUEST = 'CREATE_WORK_ORDER_MESSAGE_REQUEST'
export const CREATE_WORK_ORDER_MESSAGE_SUCCESS = 'CREATE_WORK_ORDER_MESSAGE_SUCCESS'
export const CREATE_WORK_ORDER_MESSAGE_FAILURE = 'CREATE_WORK_ORDER_MESSAGE_FAILURE'

export function createMessageForWorkOrder (workOrderId, data) {
  return createResource({
    url: `/work_orders/${workOrderId}/messages`,
    key: 'message',
    schema: messageSchema,
    actions: [ CREATE_WORK_ORDER_MESSAGE_REQUEST, CREATE_WORK_ORDER_MESSAGE_SUCCESS, CREATE_WORK_ORDER_MESSAGE_FAILURE ],
    data,
    responseInterceptor: (response) => ({ ...response, workOrderId })
  })
}

export const FETCH_WORK_ORDER_MESSAGES_REQUEST = 'FETCH_WORK_ORDER_MESSAGES_REQUEST'
export const FETCH_WORK_ORDER_MESSAGES_SUCCESS = 'FETCH_WORK_ORDER_MESSAGES_SUCCESS'
export const FETCH_WORK_ORDER_MESSAGES_FAILURE = 'FETCH_WORK_ORDER_MESSAGES_FAILURE'

export function fetchMessagesForWorkOrder (workOrderId) {
  return fetchCollection({
    url: `/work_orders/${workOrderId}/messages`,
    key: 'messages',
    schema: messageSchema,
    actions: [ FETCH_WORK_ORDER_MESSAGES_REQUEST, FETCH_WORK_ORDER_MESSAGES_SUCCESS, FETCH_WORK_ORDER_MESSAGES_FAILURE ],
    responseInterceptor: (response) => ({ ...response, workOrderId })
  })
}

export const FETCH_WORK_ORDER_UNREAD_MESSAGES_REQUEST = 'FETCH_WORK_ORDER_UNREAD_MESSAGES_REQUEST'
export const FETCH_WORK_ORDER_UNREAD_MESSAGES_SUCCESS = 'FETCH_WORK_ORDER_UNREAD_MESSAGES_SUCCESS'
export const FETCH_WORK_ORDER_UNREAD_MESSAGES_FAILURE = 'FETCH_WORK_ORDER_UNREAD_MESSAGES_FAILURE'

export function fetchUnreadMessagesForWorkOrder (workOrderId) {
  return fetchCollection({
    url: `/work_orders/${workOrderId}/messages/unread`,
    key: 'messages',
    schema: messageSchema,
    actions: [
      FETCH_WORK_ORDER_UNREAD_MESSAGES_REQUEST,
      FETCH_WORK_ORDER_UNREAD_MESSAGES_SUCCESS,
      FETCH_WORK_ORDER_UNREAD_MESSAGES_FAILURE
    ],
    responseInterceptor: (response) => ({ ...response, workOrderId })
  })
}

export const DELETE_MESSAGE_REQUEST = 'DELETE_MESSAGE_REQUEST'
export const DELETE_MESSAGE_SUCCESS = 'DELETE_MESSAGE_SUCCESS'
export const DELETE_MESSAGE_FAILURE = 'DELETE_MESSAGE_FAILURE'

export function deleteUnreadMessage (messageId) {
  return deleteResource({
    url: `/messages/${messageId}`,
    actionPayload: { resourceId: messageId },
    actions: [ DELETE_MESSAGE_REQUEST, DELETE_MESSAGE_SUCCESS, DELETE_MESSAGE_FAILURE ]
  })
}



// WEBPACK FOOTER //
// ./src/actions/messages.js